import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill", "fill-opacity"]

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownFilledIcon',
  props: {
  fill: {
    type: String,
    default: 'black',
  },
  fillOpacity: {
    type: String as PropType<'1' | '0.54'>,
    default: '1',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M7 10L12 15L17 10H7Z",
      fill: __props.fill,
      "fill-opacity": __props.fillOpacity
    }, null, 8, _hoisted_2)
  ]))
}
}

})